require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./relazioni-e-conferenze-matteo-iannello-museografia-e-museologia-nel-cantone-ticino-il-castello-di-montebello-e-il-recupero-dei-tre-castelli-medievali-di-bellinzona-palermo-11-settembre-2021.json") })
        }
      }, "path---relazioni-e-conferenze-matteo-iannello-museografia-e-museologia-nel-cantone-ticino-il-castello-di-montebello-e-il-recupero-dei-tre-castelli-medievali-di-bellinzona-palermo-11-settembre-2021");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---relazioni-e-conferenze-matteo-iannello-museografia-e-museologia-nel-cantone-ticino-il-castello-di-montebello-e-il-recupero-dei-tre-castelli-medievali-di-bellinzona-palermo-11-settembre-2021!./.cache/json/relazioni-e-conferenze-matteo-iannello-museografia-e-museologia-nel-cantone-ticino-il-castello-di-montebello-e-il-recupero-dei-tre-castelli-medievali-di-bellinzona-palermo-11-settembre-2021.json
// module id = 711
// module chunks = 231608221292675